// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YcY2","option":"styles_option__xwvxK","active":"styles_active__239Uo"};